(() => {
  'use strict';
  const toggle = document.querySelector('.cc-menu-toggle');
  const nav = document.getElementById('cc-navigation');
  if (toggle && nav) {
    const setMenu = open => {
      toggle.setAttribute('aria-expanded', String(open));
      nav.classList.toggle('is-open', open);
    };
    toggle.addEventListener('click', () => setMenu(toggle.getAttribute('aria-expanded') !== 'true'));
    nav.addEventListener('click', e => { if (e.target.closest('a')) setMenu(false); });
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && toggle.getAttribute('aria-expanded') === 'true') {
        setMenu(false);
        toggle.focus();
      }
    });
    const wide = window.matchMedia('(min-width: 801px)');
    wide.addEventListener('change', () => setMenu(false));
  }
  document.querySelectorAll('[data-cc-video-container]').forEach(container => {
    const video = container.querySelector('video');
    const source = video?.querySelector('source[data-src]');
    const button = container.querySelector('.cc-video-toggle');
    if (!video || !source || !button) return;
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    let visible = false, userPaused = false, failed = false;
    video.muted = true; video.defaultMuted = true; video.playsInline = true;
    const update = () => {
      const label = video.paused ? 'Reproducir video' : 'Pausar video';
      button.textContent = label;
      button.setAttribute('aria-label', label + ' de Alejandro');
    };
    const fallback = () => { failed = true; video.pause(); container.classList.remove('cc-video-ready'); button.hidden = true; };
    const play = automatic => {
      if (failed || (automatic && (reduced.matches || userPaused || !visible))) return;
      video.autoplay = automatic;
      if (!source.src) { source.src = source.dataset.src; video.load(); }
      video.muted = true;
      video.play().catch(() => { if (video.error) fallback(); else update(); });
    };
    video.addEventListener('playing', () => { container.classList.add('cc-video-ready'); update(); });
    video.addEventListener('pause', update);
    video.addEventListener('error', fallback); source.addEventListener('error', fallback);
    button.addEventListener('click', () => {
      if (video.paused) { userPaused = false; play(false); }
      else { userPaused = true; video.autoplay = false; video.pause(); }
    });
    reduced.addEventListener('change', () => {
      if (reduced.matches) { video.autoplay = false; video.pause(); }
      else if (!userPaused) play(true);
    });
    button.hidden = false; update();
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => {
        visible = entries[0].isIntersecting;
        if (visible) play(true);
        else video.pause();
      }, {threshold: 0.15});
      observer.observe(container);
    }
  });
})();
